import './imagetext.less'

import {Background} from '@codeurs/front'
import placeholder from 'assets/images/placeholder.jpg'
import React from 'react'
import {ImageType, LinkType, WysiwygType} from 'types'
import {style} from 'util/style'
import {Trusted} from 'util/trusted'
import {Theme} from 'views/theme'

const styles = style('imagetext')

export type ImagetextType = {
	id?: string
	background?: boolean
	image?: ImageType
	image_position?: 'left' | 'right'
	title?: string
	subtitle?: string
	text?: WysiwygType
	links_layout?: 'button' | 'link'
	links?: Array<LinkType>
}

export const Imagetext: React.FC<ImagetextType> = ({
	background,
	id,
	image,
	image_position = 'left',
	title,
	subtitle,
	text,
	links_layout = 'link',
	links
}) => {
	const TagContainer = background ? 'div' : Theme.Container

	return (
		<div
			className={styles()
				.mod({background})
				.mod(image_position)}
			id={id}
		>
			<Theme.OuterContainer>
				<TagContainer>
					<div className={styles('row')}>
						<div className={styles('image')}>
							<Background img={image ? image : placeholder} />
							<div className={styles('image-overlay')} />
						</div>
						<div className={styles('content')}>
							<div className={styles('content-container')}>
								{title && (
									<Theme.H2 className={styles('content-title')}>
										<Trusted>{title}</Trusted>
									</Theme.H2>
								)}
								{/* {subtitle && (
									<Theme.H3 className={styles('content-subtitle')} mod="light">
										{subtitle}
									</Theme.H3>
								)} */}
								<div className={styles('content-description')}>
									{text && (
										<div className={styles('content-description-text')}>
											<Theme.Wysiwyg mod={background && 'inherit'}>
												{text}
											</Theme.Wysiwyg>
										</div>
									)}
									{links_layout === 'button' ? (
										<Theme.ButtonsMap
											links={links}
											className={styles('content-description-links')}
										/>
									) : (
										<Theme.LinksMap
											links={links}
											className={styles('content-description-links')}
										/>
									)}
								</div>
							</div>
						</div>
					</div>
				</TagContainer>
			</Theme.OuterContainer>
		</div>
	)
}
